import { IStore } from 'src/interfaces/store';
import { StoreExtractor } from './types';
import _ from 'lodash';

const TYPE_OBJECT = 'object';

/**
 * Create a store filter
 * @param extractor - The extractor to use
 * @returns A function that filters stores
 */

export const createStoreFilter =
    <T>(extractor: StoreExtractor<T>) =>
    (stores: IStore[], makeId?: string): T[] => {
        const extracted = stores
            .filter((store) => extractor.shouldInclude(store, makeId))
            .map((store) => extractor.extract(store));

        if (typeof extracted[0] === TYPE_OBJECT)
            return _.uniqBy(extracted, '_id');

        return _.uniq(extracted);
    };
